var body_margin = 0;

const fixedBody = (active_elem) => {

    let offset = document.scrollingElement.scrollTop;
    let $html = document.querySelector("html");
    let $body = document.querySelector("body");

    if (!hasClass(active_elem, "active")) {

        rmClass($html, "fixed-body");
        rmClass($body, "fixed-body");
        document.scrollingElement.scrollTop = body_margin;

    } 
    
    else {

        addClass($html, "fixed-body");
        addClass($body, "fixed-body");
        body_margin = offset;

    }

    $body.style.marginTop = offset * (-1) + "px";

};

const $btn_mobile_menu = document.querySelector(".btn-hamburger");
const $navigation = document.querySelector(".menu-main-container");

const menuMobileBtn = () => {
    if ($btn_mobile_menu == null) { return false; }
    $btn_mobile_menu.classList.toggle("active");
    $navigation.classList.toggle("active");
    fixedBody($btn_mobile_menu);
}

window.addEventListener("load", function() {
    $btn_mobile_menu.addEventListener("click", menuMobileBtn);

    jQuery(".menu-item-has-children > a").on("click", function(e) {
        e.preventDefault();

        var clicked = parseInt(jQuery(this).attr("data-clicked"), 10) || 0;
        clicked = clicked + 1;
        jQuery(this).attr("data-clicked", clicked);

        if (clicked % 2 == 0) {
            var href = jQuery(this).attr("href");
            window.location.href = href;
            // if (href != "#") {
                // jQuery(this).parent().removeClass("active");
            // }
        }
        // else if (clicked == "1") {
            // jQuery(this).parent().addClass("active");
        // }
        jQuery(this).parent().toggleClass("active");

    });
});